// 역할 상수
export const ROLES = {
  user: { label: "이용자", value: "user" },
  collector: { label: "수거자", value: "collector" },
  admin: { label: "관리자", value: "admin" },
  partner: { label: "파트너", value: "partner" },
  dream_user: { label: "드림 이용자", value: "dream_user" },
  dream_collector: { label: "드림 수거자", value: "dream_collector" },
};

export const ROLE_LIST = Object.values(ROLES);
export const ECOPICK_ROLE_LIST = [ROLES.user, ROLES.collector, ROLES.admin, ROLES.partner];
export const DREAM_ROLE_LIST = [ROLES.dream_user, ROLES.dream_collector];

// 소재 상수
export const MATERIALS = {
  pet: { label: "페트", color: "#8884d8" },
  aluminum: { label: "알루미늄", color: "#82ca9d" },
  mixed: { label: "혼합", color: "#ffc658" },
  paper: { label: "파지", color: "#8B4513" },
};

// 수거 희망 품목 상수
export const WANT_ITEMS = {
  wantMixedPet: "혼합 PET",
  wantPet: "일반 PET",
  wantAluminum: "알루미늄",
  wantPaper: "파지",
};

// 기간 탭 상수
export const PERIOD_TABS = [
  { label: "월별", value: "monthly" },
  { label: "주별", value: "weekly" },
  { label: "일별", value: "daily" },
];
